module.exports = __webpack_public_path__ + "static/media/Export_Icon.a5203140.svg";